export const SIDEBAR_OPEN = 'SIDEBAR_OPEN';
export const SIDEBAR_TOGGLE = 'SIDEBAR_TOGGLE';
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE';

export const SCHEDULES_CHANGED = 'SCHEDULES_CHANGED';

export const DISH_UPLOAD_IMAGES_CANCELED = 'DISH_UPLOAD_IMAGES_CANCELED';

export const LAYOUT_DEFAULT_SLIDE_OPEN_WEST_SLIDE = 'LAYOUT_DEFAULT_SLIDE_OPEN_WEST_SLIDE';
export const LAYOUT_DEFAULT_SLIDE_CLOSE_WEST_SLIDE = 'LAYOUT_DEFAULT_SLIDE_CLOSE_WEST_SLIDE';
export const LAYOUT_DEFAULT_SLIDE_TOGGLE_WEST_SLIDE = 'LAYOUT_DEFAULT_SLIDE_TOGGLE_WEST_SLIDE';
export const LAYOUT_DEFAULT_SLIDE_MOVE = 'LAYOUT_DEFAULT_SLIDE_MOVE';

export const SHOW_PAGE_MAKE_COPY = 'SHOW_PAGE_MAKE_COPY';
export const SHOW_PAGE_PROGRAM_REPORTS = 'SHOW_PAGE_PROGRAM_REPORTS';
export const SHOW_PAGE_MAKE_COPY_PROGRAM = 'SHOW_PAGE_MAKE_COPY_PROGRAM';
export const SHOW_PAGE_SEND_PROGRAM_TO_PARTICIPANT = 'SHOW_PAGE_SEND_PROGRAM_TO_PARTICIPANT';

export const SHOW_PAGE_HELP = 'SHOW_PAGE_HELP';

export const LAYOUT_MOBILE_READY_TOGGLE_SIDEBAR = 'LAYOUT_MOBILE_READY_TOGGLE_SIDEBAR';



// WEBPACK FOOTER //
// ./src/constants/event.js